import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { DatePicker, Input } from 'tea-component';
import DatePickerWrapper from '@gp/components/DatePickerWrapper';
import FollowerRange from '@gp/components/FollowerRange';
import AutoTextarea from '@gp/components/AutoTextareaNew';
import OperationBtns from '@gp/components/OperationBtns';
import { ACTION_ITEM_STATUS_OPTIONS } from '@gp/constants/const';
import { RISK_TYPES } from '@gp/pages/Pipeline/ProjectDetails/ProjectUpdate/constants';
import type { IBaseProps } from '@home/types/common';
import type { IRecord } from '@gp/types/global';

import './item.scss';

interface IActionItemProps extends IBaseProps {
  index: number;
  isShowDelete?: boolean;
  isShowAdd?: boolean;
  data?: IRecord | null;
  onAdd?: () => void;
  onDelete?: () => void;
  onChange?: (payload: IRecord) => void;
}

const ActionItem: React.FC<IActionItemProps> = (props) => {
  const {
    style,
    className,
    index,
    isShowDelete = false,
    isShowAdd = false,
    data,
    onAdd,
    onDelete,
    onChange,
  } = props;
  const {
    status,
    comment,
    due_date: dueDate,
    user_id: userId,
    user_name: userName,
    category,
  } = data || {};
  const isCategoryValid = !!category;
  const commentTrim = comment?.trim() || '';
  const isDueDateValid = !!dueDate && !!moment(dueDate)?.isValid();

  return (
    <div
      style={style}
      className={classnames('dbg-edit-form-box-item', className, {
        'dbg-is-error': !isDueDateValid || !status || !(userId && userName) || !commentTrim,
      })}
    >
      <div className="dbg-edit-form-box-label">Item {index + 1}</div>
      <div className="dbg-edit-form-box-content">
        {/* <FollowerRange
          className={classnames({ 'dbg-is-error': !isCategoryValid })}
          label="Category"
          placeholder="Please select"
          customizePlaceholder="Please input Risks name"
          options={RISK_TYPES}
          value={category}
          onChange={(value) => {
            onChange?.({ category: value });
          }}
        /> */}
        {/* 日期选择 */}
        <DatePickerWrapper className={classnames({ 'dbg-is-error': !isDueDateValid })} label="DUE">
          <DatePicker
            key={Date.now()}
            placeholder="Select Date"
            defaultValue={isDueDateValid ? moment(dueDate, 'YYYY-MM-DD') : undefined}
            onChange={(value) => {
              onChange?.({ due_date: value?.format('YYYY-MM-DD') || '' });
            }}
          />
        </DatePickerWrapper>
        <div className="dbg-update-edit-divider">-</div>
        <Input
          className={classnames({ 'dbg-is-error': !userName })}
          placeholder="Please input Team Name"
          value={userName || ''}
          onChange={(payload?: string) => {
            const userName = payload || '';
            onChange?.({ user_id: userName, user_name: userName });
          }}
        />
        <div className="dbg-update-edit-divider">-</div>
        <FollowerRange
          className={classnames('dbg-edit-form-source-selector', { 'dbg-is-error': !status })}
          boxClassName="dbg-edit-form-source-selector-box"
          matchButtonWidth
          label="Status"
          placeholder="Please select"
          isCustomize={false}
          options={ACTION_ITEM_STATUS_OPTIONS}
          value={status ? String(status) : ''}
          onChange={(value) => {
            onChange?.({ status: value });
          }}
        />
        <div className="dbg-edit-form-box-flex">
          <AutoTextarea
            className={classnames('dbg-update-edit-textarea', { 'dbg-is-error': !commentTrim })}
            placeholder="Please input other Action Item comment"
            value={comment}
            onChange={(value) => {
              onChange?.({ comment: value });
            }}
          />
          {/* 操作按钮 */}
          <OperationBtns
            className="dbg-update-project-edit-operate"
            isShowDelete={isShowDelete}
            isShowAdd={isShowAdd}
            onAdd={onAdd}
            onDelete={onDelete}
          />
        </div>
      </div>
    </div>
  );
};

export default ActionItem;
